import IconEdit from '../../assets/Icons/icon-edit.svg'

export const PxoDemandTable = ({ tableData, onClickButton, onClickEditButton }) => {
    
    const demandPostColumns = tableData?.demandPostColumns ?? []
    const demandPostRows    = tableData?.demandPostRows ?? []

    const isRedButton       = tableData.considerInDescargaTable? true : false

    return (
        <>
            <div className="flex justify-between ">
                
                
                <h2>{tableData["ownerDemandRailway.name"]}</h2>
                
                <div className="flex flex-row gap-2">
                <button
                    className={`
                        w-fit 
                        h-fit 
                        btn-cinza
                        aspect-square
                        px-[7px]
                        rounded-[5px]
                        [transition:0.3s_ease]
                    `}
                    onClick={() => onClickEditButton(tableData.id)}
                >
                    <img className="h-[10px]" src={IconEdit} alt="edit" />
                </button>


                <button
                    className={`
                        w-fit 
                        h-fit 
                        ${isRedButton ? 'btn-vermelho' : 'btn-letra-verde'} 
                        aspect-square
                        px-[7px]
                        rounded-[5px]
                        [transition:0.3s_ease]
                    `}
                    onClick={() => onClickButton(tableData.id)}
                >
                    {isRedButton ? '-' : '+'} 
                </button>
                </div>
            </div>

            <table className=" rounded-[8px] [border-spacing:0] border-separate min-w-full border">
                <thead className=" bg-neutro ">
                    <tr>

                        <th className='rounded-tl-[8px] font-small text-[small] p-[0.5rem] border-b-[1px_solid_#e3e2e2] text-center'>Terminal</th>
                        <th className='font-small text-[small] p-[0.5rem] border-b-[1px_solid_#e3e2e2] text-center'>Produto</th>

                        {demandPostColumns.map((column, index) => (
                            <th key={index}>{column.name}</th>
                        ))}
                    </tr>
                </thead>

                <tbody>
                    
                    {demandPostRows.map((row, rowIndex) => (
                        
                        <tr key={rowIndex}>


                            <td className="text-[smaller] border text-sm text-left px-2">{row.ownerTerminal.name}   </td>
                            <td className="text-[smaller] border text-sm text-left px-2">{row.ownerProduct.name}    </td>

                            {demandPostColumns.map((column, colIndex) => {
                                const value = row.demands?.find(
                                    (item) => item.demandPostColumnId === column.id
                                )

                                return <td key={colIndex} className="text-[smaller] border text-sm text-right px-2">{Number(value.wagons).toFixed(1)}</td>
                            })}
                        </tr>

                    ))}

                </tbody>
            </table>
        </>
    )
}

export default PxoDemandTable